import React from 'react';
import ScheduledMessagesPage from '../ScheduledMessages/components/ScheduledMessagesPage';

function AdminScheduledMessagesList() {
  return <ScheduledMessagesPage mode="admin" />;
}

export default AdminScheduledMessagesList;
